import { API_ROUTES_FOR_AXIOS } from '../constants/ApiRoutes';
import { axiosInstance } from '../constants/axiosInstance';
import { ApiResponse } from 'src/types/commonResponseTypes';
import {
  TotalInteractionCountApiResponse,
  TotalSpacesCountApiResponse,
  InteractionCountByDay,
  SlashCommandsCountsResponse,
  TotalCountApiResponse,
  UsageCountByUser,
  UsageCountBySpace,
} from 'src/types/overview';
import { TotalUsersCountApiResponse } from 'src/types/user';
import { handleError } from 'src/utils/commonErrorUtils';

export const getTotalActiveSpacesIntegrated = async (): Promise<
  ApiResponse<TotalSpacesCountApiResponse>
> => {
  try {
    const apiUrl = API_ROUTES_FOR_AXIOS['getTotalActiveSpacesIntegrated']();
    const { data } = await axiosInstance.get(apiUrl);

    return data;
  } catch (error) {
    return handleError(error);
  }
};

export const getTotalUsersAuthorized = async (): Promise<
  ApiResponse<TotalUsersCountApiResponse>
> => {
  try {
    const apiUrl = API_ROUTES_FOR_AXIOS['getTotalUsersAuthorized']();
    const { data } = await axiosInstance.get(apiUrl);

    return data;
  } catch (error) {
    return handleError(error);
  }
};

export const getOrganizationInteractionCountForMonth = async (
  currentDate: string,
): Promise<ApiResponse<TotalInteractionCountApiResponse>> => {
  try {
    const apiUrl =
      API_ROUTES_FOR_AXIOS['getOrganizationInteractionCountForMonth'](
        currentDate,
      );
    const { data } = await axiosInstance.get(apiUrl);

    return data;
  } catch (error) {
    return handleError(error);
  }
};

export const getUserInteractionCountForMonth = async (
  currentDate: string,
): Promise<ApiResponse<TotalInteractionCountApiResponse>> => {
  try {
    const apiUrl =
      API_ROUTES_FOR_AXIOS['getUserInteractionCountForMonth'](currentDate);
    const { data } = await axiosInstance.get(apiUrl);

    return data;
  } catch (error) {
    return handleError(error);
  }
};

export const getUserInteractionDataForSelectedDates = async (
  startDate: string,
  endDate: string,
  timeZoneOffset: string,
): Promise<ApiResponse<InteractionCountByDay[]>> => {
  try {
    const apiUrl = API_ROUTES_FOR_AXIOS[
      'getUserInteractionDataForSelectedDates'
    ](startDate, endDate, timeZoneOffset);
    const { data } = await axiosInstance.get(apiUrl);

    return data;
  } catch (error) {
    return handleError(error);
  }
};

export const getOrgInteractionDataForSelectedDates = async (
  startDate: string,
  endDate: string,
  timeZoneOffset: string,
): Promise<ApiResponse<InteractionCountByDay[]>> => {
  try {
    const apiUrl = API_ROUTES_FOR_AXIOS[
      'getOrgInteractionDataForSelectedDates'
    ](startDate, endDate, timeZoneOffset);
    const { data } = await axiosInstance.get(apiUrl);

    return data;
  } catch (error) {
    return handleError(error);
  }
};

export const getSlashCommandsCount = async (
  startDate: string,
  endDate: string,
): Promise<ApiResponse<SlashCommandsCountsResponse[]>> => {
  try {
    const apiUrl = API_ROUTES_FOR_AXIOS['getSlashCommandsCount'](
      startDate,
      endDate,
    );

    const { data } = await axiosInstance.get(apiUrl);

    return data;
  } catch (error) {
    return handleError(error);
  }
};

export const getMemoriesCountByOrgId = async (): Promise<
  ApiResponse<TotalCountApiResponse>
> => {
  try {
    const apiUrl = API_ROUTES_FOR_AXIOS['getMemoriesCount']();

    const { data } = await axiosInstance.get(apiUrl);

    return data;
  } catch (error) {
    return handleError(error);
  }
};

export const getMostActiveUsers = async (
  startDate: string,
  endDate: string,
  limit = 5,
): Promise<ApiResponse<UsageCountByUser[]>> => {
  try {
    const apiUrl = API_ROUTES_FOR_AXIOS['getMostActiveUsers'](
      startDate,
      endDate,
      limit,
    );

    const { data } = await axiosInstance.get(apiUrl);

    return data;
  } catch (error) {
    return handleError(error);
  }
};

export const getTasksCountByOrgId = async (): Promise<
  ApiResponse<TotalCountApiResponse>
> => {
  try {
    const apiUrl = API_ROUTES_FOR_AXIOS['getTasksCount']();

    const { data } = await axiosInstance.get(apiUrl);

    return data;
  } catch (error) {
    return handleError(error);
  }
};

export const getMostActiveSpaces = async (
  startDate: string,
  endDate: string,
  limit = 5,
): Promise<ApiResponse<UsageCountBySpace[]>> => {
  try {
    const apiUrl = API_ROUTES_FOR_AXIOS['getMostActiveSpaces'](
      startDate,
      endDate,
      limit,
    );

    const { data } = await axiosInstance.get(apiUrl);

    return data;
  } catch (error) {
    return handleError(error);
  }
};
